import React from "react";

import { MDBContainer, MDBRow, MDBCol, MDBFooter, MDBBtn } from "mdbreact";

import Logo from "../../assets/images/img-logo.svg";

export default function MainFooter() {
	return (
		<MDBFooter className="py-3 bg-green">
			<MDBContainer className="my-4 text-center text-md-left">
				<MDBRow>
					<MDBCol col="12" md="6">
						<h5>Conheça os portais da Universidade Feevale</h5>
						<ul className="pl-0 pl-md-5 list-unstyled">
							{[
								["https://www.feevale.br", "Universidade Feevale"],
								["https://graduacao.feevale.br", "Graduação"],
								["https://pos.feevale.br", "Especializações e MBAs"],
								["https://www.feevale.br/stricto", "Mestrados e doutorados"],
								["https://escola.feevale.br", "Escola de Aplicação"],
								["https://www.feevale.br/idiomas", "Idiomas"],
								["https://feevaletechpark.com.br", "Feevale Techpark"],
								["https://teatrofeevale.com.br", "Teatro Feevale"],
								["https://editais.feevale.com.br", "Editais"]
							].map((i, index) => {
								return (
									<li key={"link" + index}>
										<a href={i[0]} target="_blank" className="text-white" rel="noreferrer">{i[1]}</a>
									</li>
								);
							})}
						</ul>
					</MDBCol>
					<MDBCol col="12" md="6">
						<MDBContainer fluid>
							<MDBRow>
								<MDBCol>
									<h5>Fale conosco</h5>
								</MDBCol>
							</MDBRow>
							<MDBRow>
								<MDBCol>
									<a href="https://www.feevale.br/institucional/fale-com-a-feevale" target="_blank" rel="noreferrer">
										<MDBBtn color="white" outline className="w-100">Acesse</MDBBtn>
									</a>
								</MDBCol>
							</MDBRow>
						</MDBContainer>
					</MDBCol>
				</MDBRow>
				<MDBRow>
					<MDBCol className="text-center">
						<a href="https://www.feevale.br" target="_blank" rel="noreferrer">
							<img
								src={Logo}
								className="img-fluid"
								style={{ width: 180 }}
								alt="Universidade Feevale"
								title="Universidade Feevale"
							/>
						</a>
					</MDBCol>
				</MDBRow>
			</MDBContainer>
		</MDBFooter>
	);
}
